import { styled } from 'styles/stitches.config'

export const Main = styled('main', {
  '& section': {
    paddingTop: 100,
    paddingBottom: 100,
  },
})
